import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectUserId } from '../Login/loginSlice';
import { getReferrals } from './cooperationApi';
import './Cooperation.css';

const Cooperation = () => {
    const userId = useSelector(selectUserId);
    const [copied, setCopied] = useState(false);
    const [referrals, setReferrals] = useState([]);
    const [loading, setLoading] = useState(true);

    const referralLink = `${window.location.origin}/dentapp/login?ref_id=${userId}`;

    useEffect(() => {
        if (userId) {
            setLoading(true);
            getReferrals({ user_id: userId }, (data) => {
                if (data.res && data.referrals) {
                    setReferrals(data.referrals);
                } else {
                    setReferrals([]);
                }
                setLoading(false);
            });
        }
    }, [userId]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(referralLink);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 3000);
        } catch (err) {
            console.error('Ошибка при копировании:', err);
            // Fallback для старых браузеров
            const textArea = document.createElement('textarea');
            textArea.value = referralLink;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                const success = document.execCommand('copy');
                if (success) {
                    setCopied(true);
                    setTimeout(() => {
                        setCopied(false);
                    }, 3000);
                }
            } catch (e) {
                console.error('Ошибка при копировании (fallback):', e);
            } finally {
                document.body.removeChild(textArea);
            }
        }
    };

    return (
        <div className="cooperation-container">
            <h1>Сотрудничество</h1>
            
            <div className="cooperation-referral-section">
                <div className="cooperation-referral-label">Скопировать рефер ссылку</div>
                <div className="cooperation-referral-link-container">
                    <input 
                        type="text" 
                        className="cooperation-referral-input"
                        value={referralLink}
                        readOnly
                    />
                    <button 
                        className="cooperation-copy-button"
                        onClick={handleCopy}
                        title="Копировать ссылку"
                    >
                        <svg 
                            width="20" 
                            height="20" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path 
                                d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" 
                                fill="currentColor"
                            />
                        </svg>
                    </button>
                </div>
                {copied && (
                    <div className="cooperation-copied-message">
                        Скопировано!
                    </div>
                )}
            </div>

            {/* Таблица рефералов */}
            <div className="cooperation-referrals-section">
                <h2 className="cooperation-section-title">Список рефералов</h2>
                
                {loading ? (
                    <div className="cooperation-loading">Загрузка...</div>
                ) : referrals.length === 0 ? (
                    <div className="cooperation-empty">Рефералов пока нет</div>
                ) : (
                    <div className="cooperation-table-container">
                        <table className="cooperation-table">
                            <thead>
                                <tr>
                                    <th>№</th>
                                    <th>Email</th>
                                    <th>Имя</th>
                                    <th>Фамилия</th>
                                    <th>Адрес</th>
                                    <th>Компания</th>
                                </tr>
                            </thead>
                            <tbody>
                                {referrals.map((referral, index) => (
                                    <tr key={referral.user_id}>
                                        <td>{index + 1}</td>
                                        <td>{referral.email || '—'}</td>
                                        <td>{referral.name || '—'}</td>
                                        <td>{referral.surname || '—'}</td>
                                        <td>{referral.country || '—'}</td>
                                        <td>{referral.company || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Cooperation;

